import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "form-floating mb-3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", { for: "login-email" }, "E-mail", -1)
const _hoisted_3 = { class: "invalid-feedback" }
const _hoisted_4 = { class: "form-floating mb-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { for: "login-password" }, "Heslo", -1)
const _hoisted_6 = { class: "invalid-feedback" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_Alert = _resolveComponent("Alert")!
  const _component_SubmitButton = _resolveComponent("SubmitButton")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createBlock(_component_Form, {
    onSubmit: _ctx.onSubmit,
    "validation-schema": _ctx.schema
  }, {
    default: _withCtx(({ errors }) => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_Field, {
          name: "email",
          class: _normalizeClass([{'is-invalid' : errors.email}, "form-control"]),
          type: "email",
          id: "login-email",
          placeholder: "vas@email.cz"
        }, null, 8, ["class"]),
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, _toDisplayString(errors.email), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_Field, {
          name: "password",
          class: _normalizeClass([{'is-invalid' : errors.password}, "form-control"]),
          type: "password",
          id: "login-password",
          placeholder: "Vaše heslo"
        }, null, 8, ["class"]),
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, _toDisplayString(errors.password), 1)
      ]),
      _createVNode(_component_Alert, {
        data: _ctx.alert,
        class: "mb-3"
      }, null, 8, ["data"]),
      _createVNode(_component_SubmitButton, {
        loading: _ctx.loading,
        "btn-title": "Přihlásit se",
        classes: "w-100 fw-bold text-uppercase"
      }, null, 8, ["loading"])
    ]),
    _: 1
  }, 8, ["onSubmit", "validation-schema"]))
}